
//utils

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

//menu mobile
$('body').on('click', '.hd__menu-btn > a', function (e) {
    e.preventDefault();

    $('body').toggleClass('--no-scroll');
    $(this).toggleClass('--close');
    $('.hd__nav').toggleClass('--open');
});

//subhd fixed
$(window).on('load scroll', function (e) {

    var st = $(window).scrollTop();

    if (st > $('#hd').height()) {
        $('#subHd').addClass('--fixed');
    } else {
        $('#subHd').removeClass('--fixed');
    }

});

//subhd class on scroll
$('.subhd__nav:not(.--no-anchors) nav > a').each(function (i, el) {
    $(window).on('scroll', function (e) {
        var st = $(window).scrollTop();

        if ($(el).attr('href') != "#") {

            var elTop = $($(el).attr('href')).offset().top;
            var offset = 0;

            if (!$($(el).attr('href')).hasClass('--color-bg')) {
                offset = 100;
            }

            if (st > (elTop - offset)) {
                $(el).addClass('--active').siblings().removeClass('--active');
            } else {
                $(el).removeClass('--active')
            }

        }
        
    });
});


//subhd anchors
$('body').on('click', '.subhd__nav:not(.--no-anchors) nav > a', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var offset = 0;

    if (href != "#") {

        if (!$(href).hasClass('--color-bg')) {
            offset = 90;
        } else {
            offset = -10;
        }

        gsap.to(window, { duration: 0.6, scrollTo: { y: href, offsetY: offset } });

        setTimeout(function () {
            $(this).addClass('--active').siblings().removeClass('--active');
        }, 700);

        //chiusura dropdown
        if (Modernizr.touchevents || $(window).width() <= 1024) {
            setTimeout(function () {
                $('.subhd__title > a').removeClass('--nav-open');
                $('.subhd__nav').removeClass('--open');
            }, 800);
        }
    }
});

//subhd dropdown mobil
$('body').on('click', '#subHd .subhd__title > a', function (e) {

    if (Modernizr.touchevents || $(window).width() <= 1024) {
        e.preventDefault();
        $(this).toggleClass('--nav-open');
        $('#subHd .subhd__nav').toggleClass('--open');
    }
});


//Accoridon
$('body').on('click', '.blocks-accordion-button > a', function (e) {
    e.preventDefault();

    var accordionBtn = e.currentTarget;
    var accordion = $(accordionBtn).closest('.blocks-accordion');
    var accordionContent = $(accordion).find('.blocks-accordion-content');

    if (accordion.hasClass('--open')) {
        accordion.removeClass('--open');
        gsap.to(accordionContent, {
            duration: 0.3,
            height: 0
        });
    } else {
        accordion.addClass('--open');
        gsap.to(accordionContent, {
            duration: 0.3,
            height: 'auto'
        });
    }
});


//Smooth Scroll onclick
$('body').on('click', '.js-smoothscroll', function (e) {
    e.preventDefault();

    var href = $(this).attr('href');
    var offset = 0;

    if (!$(href).hasClass('--color-bg')) {
        offset = 90;
    } else {
        offset = -10;
    }

    gsap.to(window, { duration: 0.6, scrollTo: { y: href, offsetY: offset } });
});


//Back btn blog post
$('.js-back-btn').on('click', function (e) {
    e.preventDefault();
    window.history.back();
});

//Slider Blocchi Editoriali

$('.block-slider.--image-slider .swiper-container').each(function (i, el) {
    new Swiper(el, {
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        slidesPerView: 1,
        spaceBetween: 50,
        autoHeight: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });

    if ($(el).find('.swiper-slide').length <= 1) {
        $(el).addClass('--noswiping');
    }
});

$('.block-slider.--caption-slider .swiper-container').each(function (i, el) {
    new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 50,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            // when window width is >= 320px
            600: {
                slidesPerView: 2,
            },
            // when window width is >= 640px
            1024: {
                slidesPerView: 3,
            }
        }
    });

    if ($(window).width() >= 1024 && $(el).find('.swiper-slide').length <= 3) {
        $(el).addClass('--noswiping');
    }
    else if (($(window).width() >= 600 && $(window).width() < 1024) && $(el).find('.swiper-slide').length <= 2) {
        $(el).addClass('--noswiping');
    }
    else if ($(window).width() < 600 && $(el).find('.swiper-slide').length <= 1) {
        $(el).addClass('--noswiping');
    }
});

$('.block-slider.--cases-slider .swiper-container').each(function (i, el) {
    new Swiper(el, {
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 25,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            // when window width is >= 320px
            600: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 50
            },
            // when window width is >= 480px
            769: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 50
            },
            // when window width is >= 640px
            1366: {
                slidesPerView: 5,
                slidesPerGroup: 5,
                spaceBetween: 50
            }
        }
    });

    if ($(window).width() >= 1366 && $(el).find('.swiper-slide').length <= 5) {
        $(el).addClass('--noswiping');
    }
    else if (($(window).width() >= 769 && $(window).width() < 1366) && $(el).find('.swiper-slide').length <= 4) {
        $(el).addClass('--noswiping');
    }
    else if (($(window).width() >= 600 && $(window).width() < 769) && $(el).find('.swiper-slide').length <= 3) {
        $(el).addClass('--noswiping');
    }
    else if ($(window).width() < 600 && $(el).find('.swiper-slide').length <= 2) {
        $(el).addClass('--noswiping');
    }
});

$('.block-slider.--number-slider .swiper-container').each(function (i, el) {
    new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 50,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            // when window width is >= 320px
            600: {
                slidesPerView: 2
            },
            // when window width is >= 480px
            769: {
                slidesPerView: 3,
            },
            // when window width is >= 640px
            1367: {
                slidesPerView: 4
            }
        }
    });

    if ($(window).width() >= 1367 && $(el).find('.swiper-slide').length <= 4) {
        $(el).addClass('--noswiping');
    }
    else if (($(window).width() >= 769 && $(window).width() < 1367) && $(el).find('.swiper-slide').length <= 3) {
        $(el).addClass('--noswiping');
    }
    else if (($(window).width() >= 600 && $(window).width() < 769) && $(el).find('.swiper-slide').length <= 2) {
        $(el).addClass('--noswiping');
    }
    else if ($(window).width() < 600 && $(el).find('.swiper-slide').length <= 1) {
        $(el).addClass('--noswiping');
    }

    //animazione numeri slide
    var animate = true;
    $(window).on('load scroll', function () {
        if (animate) {
            if ($(el).isInViewport()) {
                numberSlidesCounter($(el).find('.swiper-slide'));
                animate = false;
            }
        }
    });
});

function numberSlidesCounter(slides) {
    slides.each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.find('.slide-number').attr('data-count') }, {
            duration: 1000,
            easing: 'swing',
            step: function () {
                $this.find('.slide-number span').text(Math.ceil(this.Counter));
            }
        });
    });
}
